/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';

import { MessagesView } from '../messages/messages-view.js';

/** Therapist → Messages (Figma). Chat with their clients' parents. */
export function TherapistMessagesPage(): JSX.Element {
  return <MessagesView />;
}
